import { render, staticRenderFns } from "./orderDetailDrawer.vue?vue&type=template&id=2f2f44a3&scoped=true"
import script from "./orderDetailDrawer.vue?vue&type=script&lang=js"
export * from "./orderDetailDrawer.vue?vue&type=script&lang=js"
import style0 from "./orderDetailDrawer.vue?vue&type=style&index=0&id=2f2f44a3&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f2f44a3",
  null
  
)

export default component.exports